import React from 'react'
import styled from 'styled-components'

const PaddedSection = styled.div`
  color: ${props => props.theme.colors.error};
  text-align: center;
  padding: 2em;
  font-size: 18px;
`

const ErrorSection = ({ error, children }) => (
  <PaddedSection center>{error ? error.message : children}</PaddedSection>
)

export default ErrorSection
